<template>
    <v-dialog
            scrollable
            v-model="visible"
            max-width="900px"
            :fullscreen="fullscreen"
            :persistent="true"
    >
        <v-card>
            <v-toolbar flat dense>
                <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="fullscreen=!fullscreen">
                    <v-icon>fullscreen</v-icon>
                </v-btn>
            </v-toolbar>

            <v-divider style="max-height: 1px"/>
            <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

            <v-card-text>
                <v-form v-model="formValid" ref="formRef" lazy-validation>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs6>
                                <v-text-field label="知识产权名称" required :rules="rules.name" v-model="item.name"/>
                            </v-flex>
                            <v-flex xs3>
                                <v-autocomplete
                                        label="知识产权类型"
                                        clearable
                                        :rules="rules.required"
                                        v-model="item.typeId"
                                        item-text="name"
                                        item-value="dbid"
                                        :items="typeItems"
                                />
                            </v-flex>
                            <v-flex xs3>
                                <v-select
                                        label="知识产权属地"
                                        item-text="name"
                                        item-value="dbid"
                                        :rules="rules.required"
                                        :items="[{dbid:'gn',name:'国内'},{dbid:'gw',name:'国外'}]"
                                        v-model="item.affiliation"
                                        persistent-hint
                                ></v-select>
                            </v-flex>
                            <v-flex xs6>
                                <v-autocomplete
                                        label="归属部门"
                                        clearable
                                        :rules="rules.required"
                                        v-model="item.departmentId"
                                        item-text="name"
                                        item-value="dbid"
                                        :items="deptItems"
                                />
                            </v-flex>
                            <v-flex xs6>
                                <v-autocomplete
                                        label="代理机构"
                                        clearable
                                        :rules="rules.required"
                                        v-model="item.agencyId"
                                        item-text="name"
                                        item-value="dbid"
                                        :items="agencyItems"
                                />
                            </v-flex>
                            <v-flex xs12>
                                <x-orgs-edit
                                        label="归属单位列表"
                                        v-model="item.orgs"
                                        hint="填写归属单位列表"
                                />
                            </v-flex>
                            <v-flex xs12>
                                <x-apps-edit
                                        label="参与人列表"
                                        v-model="item.apps"
                                        hint="填写参与人列表"
                                />
                            </v-flex>
                            <v-flex xs4>
                                <v-text-field label="申请号/登记号" clearable required :rules="rules.number"
                                              v-model="item.number"/>
                            </v-flex>
                            <v-flex xs4>
                                <v-menu
                                        ref="appDateMenuRef"
                                        lazy
                                        :close-on-content-click="false"
                                        v-model="appDateMenu"
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        :nudge-right="40"
                                        max-width="290px"
                                        min-width="290px"
                                        :return-value.sync="item.appDate"
                                >
                                    <v-text-field
                                            slot="activator"
                                            label="申请日期"
                                            required
                                            :rules="rules.required"
                                            v-model="item.appDate"
                                            clearable
                                            readonly
                                    />
                                    <v-date-picker
                                            v-model="item.appDate"
                                            locale="zh-cn"
                                            type="date">
                                        <v-spacer></v-spacer>
                                        <v-btn flat color="primary" @click="appDateMenu=false">取消</v-btn>
                                        <v-btn flat color="primary" @click="$refs.appDateMenuRef.save(item.appDate)">
                                            确认
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs4>
                                <v-menu
                                        ref="authoredDateMenuRef"
                                        lazy
                                        :close-on-content-click="false"
                                        v-model="authoredDateMenu"
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        :nudge-right="40"
                                        max-width="290px"
                                        min-width="290px"
                                        :return-value.sync="item.authoredDate"
                                >
                                    <v-text-field
                                            slot="activator"
                                            label="授权日期"
                                            required
                                            :rules="rules.required"
                                            v-model="item.authoredDate"
                                            clearable
                                            readonly
                                    />
                                    <v-date-picker
                                            v-model="item.authoredDate"
                                            locale="zh-cn"
                                            type="date">
                                        <v-spacer></v-spacer>
                                        <v-btn flat color="primary" @click="authoredDateMenu=false">取消</v-btn>
                                        <v-btn flat color="primary"
                                               @click="$refs.authoredDateMenuRef.save(item.authoredDate)">确认
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs4>
                                <v-autocomplete
                                        label="流程状态"
                                        clearable
                                        :rules="rules.required"
                                        v-model="item.processStateId"
                                        item-text="name"
                                        item-value="dbid"
                                        :items="processStateItems"
                                />
                            </v-flex>
                            <v-flex xs4>
                                <v-menu
                                        ref="processStateDateMenuRef"
                                        lazy
                                        :close-on-content-click="false"
                                        v-model="processStateDateMenu"
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        :nudge-right="40"
                                        max-width="290px"
                                        min-width="290px"
                                        :return-value.sync="item.processStateDate"
                                >
                                    <v-text-field
                                            slot="activator"
                                            label="流程状态日期"
                                            required
                                            :rules="rules.required"
                                            v-model="item.processStateDate"
                                            clearable
                                            readonly
                                    />
                                    <v-date-picker
                                            v-model="item.processStateDate"
                                            locale="zh-cn"
                                            type="date">
                                        <v-spacer></v-spacer>
                                        <v-btn flat color="primary" @click="processStateDateMenu=false">取消</v-btn>
                                        <v-btn flat color="primary"
                                               @click="$refs.processStateDateMenuRef.save(item.processStateDate)">确认
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs4>
                                <v-autocomplete
                                        label="成果状态"
                                        clearable
                                        :rules="rules.required"
                                        v-model="item.outcomeStateId"
                                        item-text="name"
                                        item-value="dbid"
                                        :items="outcomeStateItems"
                                />
                            </v-flex>
                            <v-flex xs4>
                                <v-menu
                                        ref="submitDateMenuRef"
                                        lazy
                                        :close-on-content-click="false"
                                        v-model="submitDateMenu"
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        :nudge-right="40"
                                        max-width="290px"
                                        min-width="290px"
                                        :return-value.sync="item.submitDate"
                                >
                                    <v-text-field
                                            slot="activator"
                                            label="成果登记日期"
                                            required
                                            :rules="rules.required"
                                            v-model="item.submitDate"
                                            clearable
                                            readonly
                                    />
                                    <v-date-picker
                                            v-model="item.submitDate"
                                            locale="zh-cn"
                                            type="date">
                                        <v-spacer></v-spacer>
                                        <v-btn flat color="primary" @click="submitDateMenu=false">取消</v-btn>
                                        <v-btn flat color="primary"
                                               @click="$refs.submitDateMenuRef.save(item.submitDate)">确认
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs4>
                                <v-menu
                                        ref="paymentDateMenuRef"
                                        lazy
                                        :close-on-content-click="false"
                                        v-model="paymentDateMenu"
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        :nudge-right="40"
                                        max-width="290px"
                                        min-width="290px"
                                        :return-value.sync="item.paymentDate"
                                >
                                    <v-text-field
                                            slot="activator"
                                            label="缴费提醒日"
                                            required
                                            :rules="rules.required"
                                            v-model="item.paymentDate"
                                            clearable
                                            readonly
                                    />
                                    <v-date-picker
                                            v-model="item.paymentDate"
                                            locale="zh-cn"
                                            type="date">
                                        <v-spacer></v-spacer>
                                        <v-btn flat color="primary" @click="paymentDateMenu=false">取消</v-btn>
                                        <v-btn flat color="primary"
                                               @click="$refs.paymentDateMenuRef.save(item.paymentDate)">确认
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs12 sm4>
                                <v-autocomplete
                                        item-text="name"
                                        item-value="dbid"
                                        :items="agentItems"
                                        v-model="item.agentId"
                                        label="代理人"
                                        hide-details
                                        clearable
                                        :menu-props="{maxHeight:600}"
                                />
                            </v-flex>
                            <v-flex xs12 sm4>
                                <v-autocomplete
                                        label="管理人员"
                                        item-text="name"
                                        item-value="dbid"
                                        :items="managerItems"
                                        v-model="item.managerId"
                                        persistent-hint
                                        readonly
                                />
                            </v-flex>
                            <v-flex xs8>
                                <v-text-field label="备注" clearable v-model="item.notes"/>
                            </v-flex>
                            <v-flex xs12>
                                <v-textarea
                                        label="专利来源"
                                        required
                                        :rules="rules.source"
                                        v-model="item.source"
                                        persistent-hint
                                        :counter=250
                                ></v-textarea>
                            </v-flex>
                            <v-flex xs12>
                                <x-uploader
                                        label="附件列表"
                                        :action="fileUri"
                                        v-model="item.attachments"
                                        :size="Number(100)"
                                        description="附件大小不超过 100M.(上传知识产权证书和多单位合作申请的合同扫描件)"
                                />
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-spacer/>
                <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
                <v-btn color="primary" @click.native="onSave">保存
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    import XAppsEdit from '../appsEdit'
    import XOrgsEdit from '../orgsEdit'
    import XOrgsView from '../orgsView'
    import mixin from '@/mixin'
    import XUploader from '@/components/global/Uploader'
    import XUserSelectForm from '@/components/global/UserSelectForm'

    const baseUri = '/api/inte/intellectualRegist';
    const statusUri = '/api/code/status';
    const deptUri = '/api/syst/department';
    const inteTypeUri = '/api/inte/intellectualType';
    const agencyUri = '/api/inte/agency';
    const pstateUri = '/api/inte/processState/';
    const ostateUri = '/api/inte/outcomeState/';
    // const sysUserUri =  '/api/syst/user';
    const agentUri = '/api/inte/agent/';
    export default {
        mixins: [mixin.edit(baseUri)],

        components: {XAppsEdit, XOrgsEdit, XOrgsView, XUploader, XUserSelectForm},
        data() {
            return {
                formValid: false,

                fileUri: '/api/inte/file',
                item: {},
                freshItem: {
                    "name": "",
                    "typeId": "",
                    "type": "",
                    "affiliation": "",
                    "departmentId": "",
                    "department": "",
                    "agencyId": "",
                    "agency": "",
                    "agent": "",
                    "agentId": "",
                    "paymentDate": "",
                    "appDate": "",
                    "submitDate": "",
                    "authoredDate": "",
                    "number": "",
                    "source": "",
                    "status": "",
                    "managerId": "",
                    "manager": "",
                    "processStateId": "",
                    "processState": "",
                    "outcomeStateId": "",
                    "processStateDate": "",
                    "informationSource": "",
                    "apps": [],
                    "notes": "",
                    "orgs": []
                },
                affiliationMap: {
                    gn: "国内",
                    gw: "国外"
                },
                leader: {},
                //管理人员
                // managerLoading: false,
                // managerSearch: "",

                typeItems: [],
                agencyItems: [],
                deptItems: [],
                processStateItems: [],
                outcomeStateItems: [],
                agentItems: [],
                managerItems: [],

                appDateMenu: false,
                authoredDateMenu: false,
                processStateDateMenu: false,
                submitDateMenu: false,
                paymentDateMenu: false,


                /**
                 * 验证规则
                 */
                rules: {
                    name: [
                        v => !!v || '必填项。',
                        v => (v && v.length <= 255) || '长度必须小于255个字符。'
                    ],
                    typeId: [v => !!v || '必填项。'],
                    departmentId: [v => !!v || '必填项。'],
                    agencyId: [v => !!v || '必填项。'],
                    managerId: [
                        v => !!v || '必填项。'
                    ],
                }
            }
        },

        created() {
            // 加载审核状态
            this.axios.all([
                this.axios.get(statusUri, {params: {sort: 'rank.asc'}}),
                this.axios.get(inteTypeUri, {params: {sort: 'order.asc'}}),
                this.axios.get(agencyUri, {params: {sort: 'order.asc'}}),
                this.axios.get(deptUri, {params: {limit: 65535, disabled: 'F', sort: 'rank.asc'}}),
                this.axios.get(pstateUri, {params: {sort: 'order.asc'}}),
                this.axios.get(ostateUri, {params: {sort: 'order.asc'}}),
                this.axios.get(agentUri, {params: {limit: 65535, disabled: 'F', sort: 'order.asc'}}),
            ]).then(
                this.axios.spread(
                    (rspStaus, rspType, rspAgency, rspDept, rsppstate, rspostate, rspAgent) => {
                        this.statusItems = rspStaus.data.items;
                        this.typeItems = rspType.data.items;
                        this.agencyItems = rspAgency.data.items;
                        this.deptItems = rspDept.data.items;
                        this.processStateItems = rsppstate.data.items;
                        this.outcomeStateItems = rspostate.data.items;
                        this.agentItems = rspAgent.data.items;
                    }
                )
            )
        },

        watch: {},

        computed: {},

        methods: {
            // mixin 加载数据后调用
            afterGetData(data) {
                this.managerItems = data.manager ? [data.manager] : [];
            },
            //检索管理人员
            /* onManagerSearch() {
               let params = {};
               if (this.managerSearch) {
                 const val = this.managerSearch.trim();
                 if (val.length > 0) {
                   params["name"] = val;
                 }
               }
               const vm = this;
               vm.managerLoading = true;
               this.axios.get(sysUserUri, {params: params}).then(
                 rsp => {
                   vm.managerLoading = false;
                   vm.managerItems = rsp.data.items;
                 })
             },*/
        }
    }
</script>
